// extracted by mini-css-extract-plugin
module.exports = {"faded-top":"PremiumArticleEloquaForm_faded-top__GdyYJ","position-relative":"PremiumArticleEloquaForm_position-relative__xuPYt"};